import { useController, UseControllerProps } from 'react-hook-form';

import { FormControl } from '@material-ui/core';
import { FormHelperText, TextField } from '@mui/material';
import {
  DesktopDatePicker,
  DesktopDatePickerProps,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface Props
  extends Partial<DesktopDatePickerProps<Date | string, Date>>,
    UseControllerProps {
  name: string;
  required?: boolean;
  defaultValue?: any;
  disabled?: boolean;
  label?: string;
  size?: 'medium' | 'small';
}

export const DateInput: React.FC<Props> = ({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  required,
  label,
  size = 'medium',
  ...props
}) => {
  const { field, fieldState } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
  });

  return (
    <FormControl error={Boolean(fieldState.error?.message)} fullWidth>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          {...props}
          value={field.value}
          label={label}
          onChange={field.onChange}
          inputFormat="dd/MM/yyyy"
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              size={size}
              onBlur={field.onBlur}
            />
          )}
        />
      </LocalizationProvider>

      {fieldState.error?.message ? (
        <FormHelperText error={true}>
          {fieldState.error?.message}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
};
